
export const InputError = ({ error = null }) => {
    return error ? <span className='mt-10' style={{ color: '#d32f2f' }}>{error}</span> : <div className="p-10"></div>
}
